import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../../axiosInterceptor";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SwitchToggle } from "../../../helper/ImageFormat";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import { selectStyles } from "../../../utils/selectStyles";

const userSchema = Yup.object({
 role_id: Yup.string().required("Role is required"),
 userName: Yup.string().required("User name is required"),
 email: Yup.string().email("Invalid email").required("Email is required"),
 password: Yup.string().min(6, "Minimum 6 characters"),
});

const AddHandler = () => {
 const location = useLocation();
 const navigator = useNavigate();

 const editData = location.state;
 const editingId = editData?.id;

 const [loading, setLoading] = useState(false);
 const [roles, setRoles] = useState([]);
 const [showPassword, setShowPassword] = useState(false);
 useEffect(() => {
  const fetchRoles = async () => {
   try {
    const res = await axiosInstance.get("/role");
    const options = res.data.data.map((r) => ({
     value: r.id,
     label: r.name,
    }));
    setRoles(options);
   } catch (err) {
   return err
   }
  };
  fetchRoles();
 }, []);

 const initialValues = {
  role_id: "",
  userName: "",
  email: "",
  password: "",
  isActive: true,
 };

 const {
  errors,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  setFieldValue,
  touched,
 } = useFormik({
  initialValues,
  validationSchema: userSchema,
  onSubmit: async (values) => {
   setLoading(true);
   try {
    const payload = {
     role_id: values.role_id,
     userName: values.userName,
     email: values.email,
     password: values.password,
     isActive: values.isActive,
    };

    const response = editingId
     ? await axiosInstance.put(`/handler/${editingId}`, payload)
     : await axiosInstance.post("/handler", payload);

    if (response.status === 200 || response.status === 201) {
     toast.success(response?.data?.message);
     navigator("/user");
    }
   } catch (err) {
    toast.error(err?.response?.data?.message || "Error");
   } finally {
    setLoading(false);
   }
  },
 });
 useEffect(() => {
  if (editingId && roles.length > 0) {
   setFieldValue("role_id", editData?.role_id || "");
   setFieldValue("userName", editData?.userName || "");
   setFieldValue("email", editData?.email || "");
   setFieldValue("isActive", editData?.isActive ?? true);
  }
 }, [editingId, roles]);

 return (
  <div className="content-wrapper">
   <div className="page-header mt-5">
    <h3 className="page-title">
     {editingId ? "Update User" : "Add User"}
    </h3>
   </div>

   <div className="card">
    <div className="card-body">
     <form onSubmit={handleSubmit}>
      <div className="row g-4">
       <div className="col-md-6 mb-3">
        <label>Role</label>
        <Select
         options={roles}
         value={roles.find((r) => r.value === values.role_id) || null}
         onChange={(val) => setFieldValue("role_id", val?.value || "")}
         styles={selectStyles}
        />
        {touched.role_id && errors.role_id && (
         <div className="text-danger">{errors.role_id}</div>
        )}
       </div>
       <div className="col-md-6 mb-3">
        <label>Username</label>
        <input
         type="text"
         name="userName"
         className="form-control form-control-sm border border-dark"
         value={values.userName}
         onChange={handleChange}
         onBlur={handleBlur}
         placeholder="Enter Username"
        />
        {touched.userName && errors.userName && (
         <div className="text-danger">{errors.userName}</div>
        )}
       </div>

       <div className="col-md-6 mb-3">
        <label>Email</label>
        <input
         type="email"
         name="email"
         className="form-control form-control-sm border border-dark"
         placeholder="Enter Email"
         value={values.email}
         onChange={handleChange}
         onBlur={handleBlur}
        />
        {touched.email && errors.email && (
         <div className="text-danger">{errors.email}</div>
        )}
       </div>

       {!editData?.id && (
        <div className="col-md-6 mb-3">
         <label>Password</label>

         <div style={{ position: "relative" }}>
          <input
           type={showPassword ? "text" : "password"}
           name="password"
           placeholder="Enter password"
           className="form-control form-control-sm border border-dark pe-5"
           value={values.password}
           onChange={handleChange}
           onBlur={handleBlur}
          />

          <span
           onClick={() => setShowPassword(!showPassword)}
           style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            zIndex: 2,
           }}
          >
           <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
          </span>
         </div>

         {touched.password && errors.password && (
          <div className="text-danger">{errors.password}</div>
         )}
        </div>
       )}

       <div className="col-md-12 mt-3">
        <SwitchToggle
         checked={values.isActive}
         onChange={(val) => setFieldValue("isActive", val)}
         activeLabel="Active"
         inactiveLabel="Inactive"
        />
       </div>

       <div className="col-12 mt-4 d-flex justify-content-center gap-3">
        <button
         type="submit"
         className="btn btn-primary mr-2"
         disabled={loading}
        >
         {loading ? "Loading..." : editingId ? "Update" : "Add"}
        </button>

        <Link to="/user">
         <button type="button" className="btn btn-danger">
          Cancel
         </button>
        </Link>
       </div>
      </div>
     </form>
    </div>
   </div>
  </div>
 );
};

export default AddHandler;
